export default "__VITE_ASSET__fc43e8b1__"